import type { Observable as ObservableType } from 'rxjs/Observable';
import type { VersionData } from '../../model/version/version-types.tsx';
import { fetchVersionDataRest } from '../../rest/version/index.tsx';
import type { ServiceContext } from '../service-context.tsx';

export const fetchVersionDataService = (ctx: ServiceContext): ObservableType<VersionData> =>
	fetchVersionDataRest(ctx.boardId).map((response) => response.versionData);
